import { app } from '@ekuaibao/whispered';
import { prefetchOnIdle, prefetchActions } from '../../../lib/prefetch';
export var prefetchCreateBillResources = function () {
    prefetchOnIdle('bill-crate', [
        function () { return import('../parts/right-part/billInfo/BillInfoEditable'); },
        function () { return import('../parts/right-part/billMore/MoreInfo'); },
        function () { return import('../parts/right-part/billInfo/BillInfoPart'); },
        function () { return import('../parts/right-part/billInfo/RightPartFooter'); },
        function () { return import('../parts/right-part/billInfo/RightPartHeader'); },
        {
            name: 'bill-details',
            load: function () { return import('../../../components/dynamic/Details.js'); }
        },
        function () { return import('@ekuaibao/painter/esm/index.esm.js'); },
        function () { return import('../../../components/dynamic/CustomDimension/RefCPV2Refactored'); },
        function () { return import('../../../components/dynamic/CustomDimension/hooks/useTreeSelectDependence'); },
        function () { return import('../../../components/dynamic/Money'); },
        function () { return import('../../../components/dynamic/Text'); },
        function () { return import('../../../components/dynamic/Date'); },
        function () { return import('../../../components/dynamic/Attachment'); },
        function () { return import('../../../components/dynamic/RefStaff'); },
        function () { return import('../../../components/dynamic/RefDepartment'); },
        function () { return import('../../../components/dynamic/Select'); },
        function () { return import('../../../components/dynamic/DataLink'); },
        function () { return import('../../../components/dynamic/PayeeInfo'); },
        function () { return import('../../../components/dynamic/Ref'); },
        function () { return import('../../../components/dynamic/RefDepartmentCP'); }
    ]);
};
export var prefetchCreateBillAPI = function () {
    prefetchActions('bill-api', [
        function () {
            return app.invokeService('@custom-specification:get:specificationGroups:withSpecificationVersioned', undefined, {
                hiddenLoading: true
            });
        },
        function () { return app.invokeService('@currency-manage:get:currency:modifiable'); },
        function () { return app.dataLoader('@common.currencyConfig').load(); }
    ]);
};
